/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/

export default {
    your_name             : 'Your Name',
    your_email            : 'Your Email',
    company_name          : 'Company Name',
    message               : 'Message',
    mobile                : 'Phone',
    your_file             : 'Your File',
    name                  : 'Name',
    email                 : 'E-mail',
    attachment            : 'Upload CV',
    country_selector_label: 'Country code',
    country_selector_error: 'Choose country',
    phone_number_label    : 'Phone number',
    example               : 'Example:',
    username              : 'Your Email',
    password              : 'Your Password',
    new_password          : 'New Password',
    new_password2         : 'Confirm Password',
    message_title         : 'Message Subject',

};
